import { Helmet } from 'react-helmet';

import { ChangelogTable } from '@/components';

export const ChangelogPage = () => {
    return (
        <>
            <Helmet>
                <title>Changelog</title>
            </Helmet>

            <ChangelogTable title="Changelog" />
        </>
    );
};
